import { Text } from '@usealloy/component-library';
import styled from 'styled-components';

export const StyledDropdownSingleValueText = styled(Text)`
  &&& {
    font-family: var(--cl-font-family-mono);
    width: fit-content;
    line-height: var(--cl-line-height-1);
    font-weight: bold;
  }
`;

